// extracted by mini-css-extract-plugin
module.exports = {"salaryContainer":"SalaryBlock_salaryContainer__3HP6w","details":"SalaryBlock_details__2h0hm","dollarContainer":"SalaryBlock_dollarContainer__8dLkT"};